var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0002 5H33.0002V29H35.0002V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33.0001H5V35.0001H29V33.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 20.9999H8.99976V30.9999H10.9998V20.9999Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 14.9999H15.0002V30.9999H17.0002V14.9999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.00018H21V17.0002H23V9.00018Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 5H26.9995V17H28.9995V5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.0001C23.8133 31.0001 22.6533 30.6482 21.6666 29.9889C20.6799 29.3296 19.9109 28.3925 19.4567 27.2962C19.0026 26.1998 18.8838 24.9934 19.1153 23.8295C19.3468 22.6656 19.9182 21.5965 20.7574 20.7574C21.5965 19.9183 22.6656 19.3469 23.8295 19.1154C24.9933 18.8838 26.1997 19.0027 27.2961 19.4568C28.3925 19.9109 29.3295 20.6799 29.9888 21.6666C30.6481 22.6533 31 23.8134 31 25.0001C31 26.5914 30.3679 28.1175 29.2426 29.2427C28.1174 30.3679 26.5913 31.0001 25 31.0001ZM25 21.0001C24.2089 21.0001 23.4355 21.2347 22.7777 21.6742C22.1199 22.1137 21.6072 22.7384 21.3045 23.4693C21.0017 24.2002 20.9225 25.0045 21.0769 25.7804C21.2312 26.5563 21.6122 27.2691 22.1716 27.8285C22.731 28.3879 23.4437 28.7689 24.2196 28.9232C24.9956 29.0775 25.7998 28.9983 26.5307 28.6956C27.2616 28.3928 27.8864 27.8801 28.3259 27.2223C28.7654 26.5645 29 25.7912 29 25.0001C29 23.9392 28.5786 22.9218 27.8284 22.1716C27.0783 21.4215 26.0609 21.0001 25 21.0001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7011 27.2948L27.2869 28.709L33.2831 34.7053L34.6973 33.291L28.7011 27.2948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCca);
export default __webpack_public_path__ + "static/media/cca.a9334f2885061e57c4372627b0e6670b.svg";
export { ForwardRef as ReactComponent };